import React from 'react';
import {Link} from '@mui/material';

// TODO: this is not form specific, should be moved to a more generic location

export const getURLFormattedText = (value: any): React.ReactNode => {
	if (typeof value !== 'string') return value;
	return (
		<span>
			{value.split(/(https?:\/\/.*?[^\s|'|"]+)/g).map((str) => {
				if (str.match(/^https?:\/\/.*?[^\s|'|"]+/)) {
					return (
						<Link href={str} target="_blank" rel="noopener">
							{str}
						</Link>
					);
				}
				return str;
			})}
		</span>
	);
};

export default getURLFormattedText;
